module.exports = __webpack_public_path__ + "img/spoenk.6918a9e7.jpg";